export class City {
  stateId?: number;
  zoneId?: number;
  id?: number;
  name?: string;
  formatStateName?: string;
  code?: string;
  description?: string;
  active?: boolean;
  formatActive?: string;
  createdBy?: string;
  createdDate?: Date;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
}
